const PHRASES = [
  "Local Heroes",
  "Stronger Communities",
  "Brighter Futures",
  "1% Lender Credit Toward Closing Costs",
  "Serving Those Who Serve Georgia",
];

export const Marquee = () => (
  <section
    data-testid="marquee-section"
    className="relative z-10 -my-6 rotate-[-1.2deg] scale-[1.03] border-y-2 border-[#F59E0B] bg-[#DC2626] py-4 shadow-[0_20px_60px_rgba(220,38,38,0.35)]"
  >
    <div className="flex overflow-hidden">
      <div className="animate-marquee flex shrink-0 items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center" aria-hidden={half === 1}>
            {PHRASES.concat(PHRASES).map((p, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="whitespace-nowrap px-6 font-display text-lg font-bold uppercase tracking-wide text-[#FEF3C7] sm:text-xl">
                  {p}
                </span>
                <span className="text-sm text-[#FEF3C7]/80">★</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  </section>
);
